// src/contexts/CartContext.js

import React, { createContext, useState, useEffect } from 'react';

// Creamos el contexto
export const CartContext = createContext();

// Proveedor del contexto
export const CartProvider = ({ children }) => {
  // Estado inicial del carrito
  const [cartItems, setCartItems] = useState(() => {
    // Obtener el carrito de sessionStorage si existe
    const savedCart = sessionStorage.getItem('cartItems');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Efecto para guardar el carrito en sessionStorage cada vez que cambia
  useEffect(() => {
    sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  // Función para agregar un producto al carrito
  const addToCart = (product, quantity = 1) => {
    setCartItems((prevItems) => {
      // Verificar si el producto ya está en el carrito
      const existingItem = prevItems.find((item) => item._id === product._id);
      if (existingItem) {
        // Si ya está, incrementamos la cantidad, respetando el stock
        const updatedItems = prevItems.map((item) => {
          if (item._id === product._id) {
            const newQuantity = Math.min(item.quantity + quantity, product.stock);
            return { ...item, quantity: newQuantity };
          }
          return item;
        });
        return updatedItems;
      } else {
        // Si no está, lo agregamos con la cantidad especificada
        return [...prevItems, { ...product, quantity: Math.min(quantity, product.stock) }];
      }
    });
  };

  // Función para actualizar la cantidad de un producto en el carrito
  const updateCartItemQuantity = (productId, quantity) => {
    setCartItems((prevItems) => {
      return prevItems.map((item) => {
        if (item._id === productId) {
          const newQuantity = Math.min(quantity, item.stock);
          return { ...item, quantity: newQuantity };
        }
        return item;
      });
    });
  };

  // Función para eliminar un producto del carrito
  const removeFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item._id !== productId));
  };

  // Función para vaciar el carrito (podemos eliminarla si no la necesitamos)
  const clearCart = () => {
    setCartItems([]);
  };

  // Valor del contexto
  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    updateCartItemQuantity,
    clearCart,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
